import { render, staticRenderFns } from "./VersionChecker.vue?vue&type=template&id=3152c22c&"
import script from "./VersionChecker.vue?vue&type=script&lang=js&"
export * from "./VersionChecker.vue?vue&type=script&lang=js&"
import style0 from "./VersionChecker.vue?vue&type=style&index=0&id=3152c22c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports